app.factory('userMockService', ['$q', 'baseService', 'userService', 'objectHelper',
    function ($q, baseService, userService, objectHelper) {

        function UserMockService() {

            this.getLoggedUser = function () {

                /* option 1 - load from static jsons and mimic original translation behavior */

                /*return baseService.get('./resource/mock/user.json').then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, UserVO);
                        return data;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );*/

                /* option 2 - manage from within code directly

                var d = $q.defer();

                var user = new UserVO();
                user.firstName = 'Inaczej testowy';
                user.lastName = 'Inaczej testowy';
                d.resolve(user);

                return d.promise;

                */

                /* option 3 - re-route to original service (if you want to mock just some methods)

                return userService.getLoggedUser();

                */
            };
        }

        return new UserMockService();
    }
]);
